/**
 * Represents a single step in the stepper component.
 */
export interface StepData {
	/** Unique identifier for the step */
	key: string;
	/** Display name for the step */
	name: string;
	/** Whether this step has an error */
	hasError?: boolean;
}

/**
 * Props for the Stepper component.
 */
export interface StepperProps {
	/** Array of step objects to display in the stepper */
	steps: StepData[];
	/** Currently active step - can be a step key (string) or zero-based index (number) */
	currentStep: string | number;
	/** Callback when a step is clicked - receives the step key */
	onStepClick?: (stepKey: string) => void;
}

export interface StepProps {
	index: number;
	currentStep: number;
	stepKey: string;
	name: string;
	hasError?: boolean;
	onStepClick?: (stepKey: string) => void;
	isLast?: boolean;
}

export enum StepStatus {
	DISABLED = 'DISABLED',
	CURRENT = 'CURRENT',
	COMPLETED = 'COMPLETED',
}
